import { Product } from '@ikea-aoa/component-view-3d';
import { ArmrestsByCover } from 'sofa-reborn-react';
import { ArmrestStateActions, SET_ARMRESTS, SET_SELECTED_ARMREST } from './types';

export function setArmrests(value: ArmrestsByCover): ArmrestStateActions {
	return {
		type: SET_ARMRESTS,
		value,
	};
}

export function setSelectedArmrest(value: Product | null, track: boolean): ArmrestStateActions {
	return {
		type: SET_SELECTED_ARMREST,
		value,
		track,
	};
}
